import React, { Fragment, useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import {
  Container,
  Col,
  Row,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
  Button,
} from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

import Widget from "../../components/Widget/Widget.js";
import CustomOnlyModal from "../../components/CustomModal/CustomOnlyModal";
import AddGroupSidebar from "./components/AddGroupSidebar";

import {
  fetchGroups,
  selectGroup,
  updateGroup,
  addGroup,
  removeGroup,
  updateGroupState,
} from "../../actions/group";

import s from "./Tables.module.scss";

const Groups = function () {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.groups);

  const [addSidebarOpen, setAddSidebarOpen] = useState(false);
  const [secondTableCurrentPage, setSecondTableCurrentPage] = useState(0);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState({});

  const toggle = () => setModal(!modal);

  useEffect(() => {
    dispatch(fetchGroups());
  }, [dispatch]);

  const refetchItems = () => {
    dispatch(fetchGroups());
  };

  const pageSize = 10;
  const secondTablePagesCount = Math.ceil(store.groups.length / pageSize);

  const setSecondTablePage = (e, index) => {
    e.preventDefault();
    setSecondTableCurrentPage(index);
  };

  const handleAddFacility = () => {
    setAddSidebarOpen(!addSidebarOpen);
  };

  const facilitySelected = (id) => {
    const selectedItem = store.groups.filter((item) => item.id === id)[0];
    dispatch(selectGroup(selectedItem));
    handleAddFacility();
  };

  const getItemDetails = async (id, name, code) => {
    const response = await axios.get("/groups/" + id);
    if (response.status === 200) {
      console.log({
        id,
        name,
        code,
        ...response.data.group[0],
      });
      setModalData({
        id,
        name,
        code,
        ...response.data.group[0],
      });
    }
    toggle();
  };

  const updateGroupStateFunc = (id, command) => {
    dispatch(updateGroupState(id, { command }));
  };

  return (
    <Fragment>
      <div>
        <Row>
          <Col>
            <Row className="mb-4">
              <Col>
                <Widget>
                  <div className={s.tableTitle}>
                    <div className="headline-2">Groups</div>
                    <div className="d-flex">
                      <Button
                        className="btn-rounded"
                        color="secondary-red"
                        onClick={handleAddFacility}
                      >
                        <span className="align-middle">Add</span>
                      </Button>
                    </div>
                  </div>
                  <div className="widget-table-overflow">
                    <Table
                      className="table-striped table-borderless table-hover"
                      responsive
                    >
                      <thead>
                        <tr>
                          <th>Group ID</th>
                          <th className={s.nameCol}>Name</th>
                          <th>Building ID</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {store.groups
                          .slice(
                            secondTableCurrentPage * pageSize,
                            (secondTableCurrentPage + 1) * pageSize
                          )
                          .map((item) => (
                            <tr key={uuidv4()}>
                              <td>{item.id}</td>
                              <td>{item.name}</td>
                              <td>{item.building_id}</td>
                              <td>
                                <div className={`d-flex justify-content`}>
                                  <Button
                                    className="btn-rounded mr-4 mb-3"
                                    color="info"
                                    size="xs"
                                    onClick={() =>
                                      getItemDetails(
                                        item.id,
                                        item.name,
                                        item.code
                                      )
                                    }
                                  >
                                    View
                                  </Button>
                                  <Button
                                    className="btn-rounded mr-4 mb-3"
                                    color="success"
                                    size="xs"
                                    onClick={() => facilitySelected(item.id)}
                                  >
                                    Edit
                                  </Button>
                                  <Button
                                    className="btn-rounded mr-4 mb-3"
                                    color="danger"
                                    size="xs"
                                    onClick={() =>
                                      dispatch(removeGroup(item.id))
                                    }
                                  >
                                    Delete
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                    <Pagination className="pagination-with-border">
                      <PaginationItem disabled={secondTableCurrentPage <= 0}>
                        <PaginationLink
                          onClick={(e) =>
                            setSecondTablePage(e, secondTableCurrentPage - 1)
                          }
                          previous
                          href="#top"
                        />
                      </PaginationItem>
                      {[...Array(secondTablePagesCount)].map((page, i) => (
                        <PaginationItem
                          active={i === secondTableCurrentPage}
                          key={i}
                        >
                          <PaginationLink
                            onClick={(e) => setSecondTablePage(e, i)}
                            href="#top"
                          >
                            {i + 1}
                          </PaginationLink>
                        </PaginationItem>
                      ))}
                      <PaginationItem
                        disabled={
                          secondTableCurrentPage >= secondTablePagesCount - 1
                        }
                      >
                        <PaginationLink
                          onClick={(e) =>
                            setSecondTablePage(e, secondTableCurrentPage + 1)
                          }
                          next
                          href="#top"
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                </Widget>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
      <AddGroupSidebar
        store={store}
        dispatch={dispatch}
        open={addSidebarOpen}
        handleAddItem={handleAddFacility}
        selectFacility={selectGroup}
        addItem={addGroup}
        removeFacility={removeGroup}
        refetchItems={refetchItems}
        updateItem={updateGroup}
      />
      <CustomOnlyModal
        modalTitle={`Status for ${modalData?.name} (${modalData?.code})`}
        toggle={() => toggle()}
        modalStatus={modal}
      >
        <Container fluid>
          <Row className="mt-sm">
            <Col md={6}>
              <div className={s.column}>Online Status</div>
            </Col>
            <Col md={6}>
              <div className={s.column}>{modalData?.status}</div>
            </Col>
          </Row>
          <Row className="mt-sm">
            <Col md={6}>
              <div className={s.column}>Updated At</div>
            </Col>
            <Col md={6}>
              <div className={s.column}>
                {moment(
                  modalData?.updatedAt,
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                ).format("YYYY-MM-DD HH:mm")}
              </div>
            </Col>
          </Row>

          <Row className="mt-sm">
            <Button
              className="btn-rounded btn-primary mr-3"
              onClick={() =>
                updateGroupStateFunc(modalData?.id, "open_command")
              }
            >
              Desired 1
            </Button>
            <Button
              className="btn-rounded btn-secondary mr-3"
              onClick={() =>
                updateGroupStateFunc(modalData?.id, "close_command")
              }
            >
              Desired 0
            </Button>
          </Row>
        </Container>
      </CustomOnlyModal>
    </Fragment>
  );
};

export default Groups;
